import { FC } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Button, { ButtonColorTypes } from "../../shared-components/Button";
import { usePermissionValidator } from "../../api/UserPermissionValidators";

interface SettingsNavProps {
  isSubCompany?: boolean;
}

const SettingsNav: FC<SettingsNavProps> = ({ isSubCompany = false }) => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const permissions = usePermissionValidator();

  const location = useLocation();

  const getIsActive = (path: string) => {
    return location.pathname.includes(path);
  };

  let navItems = [
    {
      name: isSubCompany ? "Sub Company Settings" : "Company Settings",
      path: "settings/general",
      permissions: isSubCompany
        ? [permissions.subcompanies.canViewSettings]
        : [permissions.companies.canViewSettings],
    },
    {
      name: "API Settings",
      path: "settings/api",
      permissions: [permissions.companies.canViewApiKeys],
    },
    {
      name: "Report Settings",
      path: "settings/reports",
      permissions: isSubCompany
        ? [permissions.subcompanies.canViewDetails]
        : [permissions.companies.canViewDetails],
    },
    {
      name: "Check Types",
      path: "settings/checktypes",
      permissions: isSubCompany
        ? [permissions.subcompanies.canViewBlueprints]
        : [permissions.companies.canViewBlueprints],
    },
    {
      name: "Behavior Kits",
      path: "settings/behavior-kits",
      permissions: isSubCompany
        ? [permissions.subcompanies.canViewBehaviorKits]
        : [permissions.companies.canViewBehaviorKits],
    },
    { name: "Screening Subscriptions", path: "settings/subscriptions" },
    {
      name: "Integrations",
      path: "settings/integrations",
      permissions: [permissions.canSelfManageATS],
    },
  ];
  navItems = navItems
    .filter((item) => {
      return (
        !item.hasOwnProperty("permissions") ||
        item.permissions?.every((perm) => perm === true)
      );
    })
    .sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

  return (
    <div className="flex flex-col gap-3 text-gray-500 w-64 p-4">
      {navItems.map((item) => (
        <div
          key={item.path}
          className={`cursor-pointer ${
            getIsActive(item.path) ? "text-green-600" : ""
          }`}
          onClick={() => navigate(`${item.path}`)}
        >
          {item.name}
        </div>
      ))}

      {!isSubCompany && permissions.subcompanies.canViewDetails && (
        <div className="mt-4">
          <Button
            text="Sub Company List"
            colorType={ButtonColorTypes.outline}
            onClick={() => {
              navigate(`/companies/${companyId}/subcompanies`);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SettingsNav;
